<template>
  <div
    ref="coordinateLabel"
    class="sd-coordinate clickable no-select round-corner"
    :id="'coordinate-label-' + type"
    v-show="labelShow_"
    @click="handleShowViewInfo"
  >
    <div ref=" lastLabel">{{ lastLabel_ }}</div>
  </div>
</template>

<script>
import { MousePosition } from 'ol/control'
import { createStringXY } from 'ol/coordinate'
import { toFixWithZero } from './Utils/StringUtil'
/**
 * @description 坐标显示
 * @author GuoYun
 */
export default {
  name: 'SdCoordinate',
  data() {
    return {
      mousePositionControl_: null,
      map_: null,
      labelShow_: false,
      coordPrecision_: 5,
      coordValueStr_: '',
      coordinatesOptions_: {
        coordinateFormat: this.defaultCoordinateFormat,
        className: 'custom-mouse-position',
        undefinedHTML: '',
      },
      lastLabel_: '',
      level_: 0,
      notify_: null,
    }
  },
  props: {
    type: {
      type: String,
      default() {
        return 'default'
      },
    },
    precision: {
      type: Number,
      default() {
        return 5
      },
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  created() {
    this.initParameter()
  },
  beforeDestroy() {
    this.removeControl()
  },
  methods: {
    initParameter() {
      this.coordPrecision_ = this.precision > 0 ? this.precision : 5
      this.coordinatesOptions_ = Object.assign(this.coordinatesOptions_, this.options, {
        target: this.$refs.coordinateLabel,
      })
    },
    setMap(map) {
      this.map_ = map
      this.addControl()
    },
    addControl() {
      this.removeControl()

      this.mousePositionControl_ = new MousePosition(this.coordinatesOptions_)
      // 添加控制控件到地图上即可
      this.map_.addControl(this.mousePositionControl_)
      // this.map_.getView().on('change', this.callbackViewChange)
    },
    callbackViewChange(event) {
      this.level_ = event.target.getZoom()
    },
    defaultCoordinateFormat(e) {
      let stringifyFunc = createStringXY(this.coordPrecision_)
      let str = stringifyFunc(e)
      this.labelShow_ = true
      this.coordValueStr_ = str
      this.lastLabel_ = 'X: ' + str.split(',')[0] + ' ' + ' Y: ' + str.split(',')[1]
      return ''
    },
    removeControl() {
      if (this.mousePositionControl_ && this.map_) {
        this.map_.removeControl(this.mousePositionControl_)
        this.mousePositionControl_ = null
      }
    },
    handleShowViewInfo() {
      const msg =
        '<div class="info-notify">' +
        '级别：' +
        this.map_?.getView().getZoom() +
        '</div>' +
        '<div class="info-notify">' +
        '视图分辨率：' +
        toFixWithZero(this.map_?.getView().getResolution() + '', 15) +
        '</div>'
      this.notify_ = this.$notify({
        title: '当前视图信息',
        dangerouslyUseHTMLString: true,
        message: msg,
        duration: 2000,
        position: 'bottom-right',
        showClose: false,
        onClick: this.handleCloseNotify,
      })
    },
    handleCloseNotify() {
      if (this.notify_) {
        this.notify_.close()
        this.notify_ = null
      }
    },

  },
}
</script>

<style scope>
/*
  鼠标坐标显示组件样式
  @component SdCoordinate
*/
.sd-coordinate {
  position: absolute;
  right: 5px;
  bottom: 5px;
  z-index: 10;
}
#coordinate-label-default {
  background: #409eff;
  padding: 10px 10px 10px 15px;
  color: white;
}
.info-notify {
  padding: 5px;
  user-select: none;
}
</style>
